// config.js - Application Configuration
export const config = {
  // Google Sheet ID for the application
  GOOGLE_SHEET_ID: '1g7OcnmajSwJeBrLmylVrG1RCWgsjMJnVvlXHKGR-XUg',
  
  // API Configuration
  API_BASE: 'https://tls.gfphoto.ch/api-hybrid.php',
  
  // App Information
  APP_VERSION: '1.5.5',
  APP_NAME: 'Trials Live Scoring',
  
  // Features
  ENABLE_SECTION_MEMORY: true,
  
  // 🆕 NOUVELLES FONCTIONNALITÉS AUTO-LAP
  ENABLE_AUTO_LAP_SELECTION: true, // Active la sélection automatique du tour suivant
  ENABLE_AUTO_LAP_NOTIFICATIONS: true, // Active les notifications de changement de tour
  AUTO_LAP_FEEDBACK: true, // Active le feedback haptique lors des changements automatiques

  // 🆕 NAVIGATION CONFIGURATION
  ENABLE_STICKY_HEADER: true, // Active la barre de navigation sticky
  ENABLE_STICKY_SCORING_HEADER: true, // Active sticky aussi pour ScoringScreen
  STICKY_HEADER_OPACITY: 0.8, // Opacité de la barre sticky (0.0 à 1.0)
  STICKY_HEADER_BLUR: true, // Active l'effet de flou derrière la barre sticky

  // UI Configuration
  RETRY_COUNTDOWN_SECONDS: 20, // Délai en secondes pour les boutons retry
};